<template>
  <div class="form-group">
    <label>
      <span v-text="formatLabel()" />
      <select
        :id="`form-field-${name}`"
        v-model="selectedValue"
        v-validate="validation"
        :class="{'is-danger': errors.has(`form-field-${name}`)}"
        :data-vv-name="`form-field-${name}`"
        :data-vv-as="formatLabel()"
        class="form-control"
      >
        <option
          :value="null"
          disabled="disabled"
        >
          -- Please select --
        </option>
        <option
          v-for="(option, index) in options"
          :key="`option-${index}`"
          :value="option.value || option"
          v-text="option.label || option"
        />
      </select>
    </label>
    <span
      v-if="errors.has(`form-field-${name}`)"
      class="has-error"
      v-text="errors.first(`form-field-${name}`)"
    />
    <span
      v-if="info"
      class="help-block"
      v-text="info"
    />
  </div>
</template>

<script>
import Field from '../field.vue';

export default {
  extends: Field,
  props: {
    options: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      selectedValue: this.value || null,
    };
  },
  watch: {
    selectedValue(newValue) {
      this.$emit('input', newValue);
    },
  },
};
</script>
